import { useState } from 'react';
import { useFetch } from './useFetch';
import { API_CONFIG } from '../config/api';

interface DeleteState {
  isLoading: boolean;
  error: string | null;
  success: boolean;
}

export const useSocialDelete = () => {
  const [deleteState, setDeleteState] = useState<DeleteState>({
    isLoading: false,
    error: null,
    success: false,
  });

  const { fetchWithAuth } = useFetch();

  const deleteSocial = async (socialId: string): Promise<boolean> => {
    setDeleteState({
      isLoading: true,
      error: null,
      success: false,
    });

    try {
      const response = await fetchWithAuth(`${API_CONFIG.BASE_URL}/socials/${socialId}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Erro ao deletar social: ${response.status} - ${errorText}`);
      }

      setDeleteState(prev => ({ ...prev, isLoading: false, success: true }));
      return true;
    } catch (error) {
      setDeleteState(prev => ({
        ...prev,
        error: error instanceof Error ? error.message : 'Erro desconhecido',
        isLoading: false,
      }));
      return false;
    }
  };

  const resetDeleteState = () => {
    setDeleteState({
      isLoading: false,
      error: null,
      success: false,
    });
  };

  return {
    deleteSocial,
    deleteState,
    resetDeleteState,
  };
};
